var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlugins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Merge",
    transform: "translate(0.473 0.403)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1459",
    "data-name": "Rectangle 1459",
    width: 21,
    height: 21,
    transform: "translate(-0.473 -0.403)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union_48",
    "data-name": "Union 48",
    transform: "translate(0 1.395)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M15.433,11.833H13.652a3.49,3.49,0,0,1-3.205-2.089L8.31,5.441A6.059,6.059,0,0,0,2.968,2H0V4.458H2.968A3.49,3.49,0,0,1,6.173,6.548l2.137,4.3a6.059,6.059,0,0,0,5.342,3.441h1.781v2.458l4.749-3.687L15.433,9.375Z",
    transform: "translate(0 0.174)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M9.378,5.324a3.2,3.2,0,0,1,2.39-.978H13.4V6.519l4.346-3.26L13.4,0V2.173h-1.63A5.1,5.1,0,0,0,8.4,3.368a6.065,6.065,0,0,1,.543.869Z",
    transform: "translate(2.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M5.107,9.1a3.2,3.2,0,0,1-2.39.978H0v2.173H2.716a5.1,5.1,0,0,0,3.368-1.2,6.065,6.065,0,0,1-.543-.869Z",
    transform: "translate(0 2.499)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlugins);
export default __webpack_public_path__ + "static/media/icon-plugins.7f5a374e98d5c9a497275906c0abd3aa.svg";
export { ForwardRef as ReactComponent };